import { FC, ReactNode, useState } from 'react';
import { AssetType } from '../../../../utils';
import { AcceptOfferStockEtfEtcEligibleTerms } from './components/AcceptOfferStockEtfEtcEligibleTerms';
import { AcceptOfferStockEtfEtcNonEligibleTerms } from './components/AcceptOfferStockEtfEtcNonEligibleTerms';
import { useClientUserInfo } from '../../../../../common/userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';
import { LegalDocumentsTermLabelTranslations } from './components/LegalDocumentsTermLabel';

export type AcceptBuyTradeDisclaimerWrapperProps = {
  translations: LegalDocumentsTermLabelTranslations & {
    investingRiskToggle: string;
    stocksToggleNotAppropriate: string;
  };
  variant: 'buy' | 'sell' | 'swap';
  legalUrl: string;
  assetType: AssetType;
  children?: (props: { areTermsAgreedTo: boolean }) => ReactNode;
};

export const AcceptBuyTradeDisclaimerWrapper: FC<
  AcceptBuyTradeDisclaimerWrapperProps
> = ({ translations, variant, children, legalUrl, assetType }) => {
  const isCrypto = assetType === 'CryptoAsset';

  const isMetalAsset = assetType === 'MetalAsset';

  const isNotCryptoOrMetal = !isCrypto && !isMetalAsset;

  const noVerificationRequired = isMetalAsset || isCrypto || variant === 'sell';

  const userData = useClientUserInfo();

  const [disclaimerAgreed, setDisclaimerAgreed] = useState(
    noVerificationRequired ? true : false,
  );

  const toggleDisclaimerAgreement = () => {
    setDisclaimerAgreed((state) => !state);
  };

  const isUserAppropriate =
    userData &&
    userData.appropriateness !== 'NOT_APPROPRIATE' &&
    userData.appropriatenessRequiresTestCompletion === false &&
    userData.appropriatenessRequiresTestResubmission === false;

  return (
    <>
      {isNotCryptoOrMetal && isUserAppropriate && !noVerificationRequired ? (
        <AcceptOfferStockEtfEtcEligibleTerms
          legalDocumentUrl={legalUrl}
          translations={translations}
          setTermsAgreed={toggleDisclaimerAgreement}
          termsAgreed={disclaimerAgreed}
        />
      ) : isNotCryptoOrMetal &&
        !isUserAppropriate &&
        !noVerificationRequired ? (
        <AcceptOfferStockEtfEtcNonEligibleTerms
          legalDocumentUrl={legalUrl}
          translations={translations}
          setTermsAgreed={setDisclaimerAgreed}
        />
      ) : null}

      {children &&
        children({
          areTermsAgreedTo: disclaimerAgreed,
        })}
    </>
  );
};
